import {
  accountColumnDefinition,
  accountDescriptionColumnDefinition,
  bookTypeColumnDefinition,
  companyCodeColumnDefinition,
  costCenterColumnDefinition,
  taxCurrencyColumnDefinition,
  customEnteredCreditColumnDefinition,
  customEnteredDebitColumnDefinition,
  geographyColumnDefinition,
  ileColumnDefinition,
  imeColumnDefinition,
  legalEntityColumnDefinition,
  localAccountColumnDefinition,
  localAccountDescriptionColumnDefinition,
  managementEntityColumnDefinition,
  plAccountJournalsDetailColumnDefinition,
  plAmountColumnDefinition,
  plAmountDescriptionColumnDefinition,
  productLineColumnDefinition,
  projectColumnDefinition,
  referenceColumnDefinition,
  tradingPartnerColumnDefinition,
} from '../columnDefinitions';

export const journalGlobalColumnDefs = [
  companyCodeColumnDefinition,
  accountColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  geographyColumnDefinition,
  projectColumnDefinition,
  referenceColumnDefinition,
  bookTypeColumnDefinition,
  productLineColumnDefinition,
  { ...taxCurrencyColumnDefinition, field: 'currency' },
  customEnteredDebitColumnDefinition,
  customEnteredCreditColumnDefinition,
  accountDescriptionColumnDefinition,
];

export const journalLocalColumnDefs = [
  legalEntityColumnDefinition,
  managementEntityColumnDefinition,
  localAccountColumnDefinition,
  ileColumnDefinition,
  imeColumnDefinition,
  bookTypeColumnDefinition,
  { ...taxCurrencyColumnDefinition, field: 'currency' },
  customEnteredDebitColumnDefinition,
  customEnteredCreditColumnDefinition,
  localAccountDescriptionColumnDefinition,
];

export const journalsDetailColumnDefs = [
  companyCodeColumnDefinition,
  bookTypeColumnDefinition,
  taxCurrencyColumnDefinition,
  plAccountJournalsDetailColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  plAmountColumnDefinition,
  plAmountDescriptionColumnDefinition,
  accountDescriptionColumnDefinition,
];
